<div class="page_layout">
  <app-page-title-gold [input_title]="Menuitem.categoryName" />
  <app-single-item-card [singleItem]="Menuitem" />
  @if (hasCoupon) {
  <app-cupon [menuItemId]="Menuitem.id" />
  }
  <app-menu-footer />
</div>

